import { ErrorPage, FilteredCreditApplication, Loader, RequiredDocumentWithStatus, useGetFeedback, useMerchantById } from '@applyonline/shared'
import { replaceWithNonBreakingHyphen } from '@applyonline/shared/utils'
import { EApplicantType } from '@if/core/types'
import { useTranslation } from 'react-i18next'
import { applicantFullName } from '../../../../data/credit-application-selectors'
import { getFeedbackStepStatus } from '../hooks'
import ContractCreditStep from './components/ContractCreditStep'
import CreditStep, { CreditStepStatus } from './components/CreditStep'
import DocumentsCreditStep from './components/DocumentsCreditStep'

interface Props {
  creditApp: FilteredCreditApplication
  skipBankAccountRequiredDocuments: RequiredDocumentWithStatus[]
}

const OverviewPage = ({ creditApp, skipBankAccountRequiredDocuments }: Props) => {
  const { t } = useTranslation()
  const [feedback, isLoadingFeedback] = useGetFeedback(creditApp.id, creditApp.financingProgramId)
  const [merchant, isLoadingMerchant] = useMerchantById(creditApp.merchantId, creditApp.financingProgramId)
  const feedbackStepStatus = getFeedbackStepStatus(creditApp, skipBankAccountRequiredDocuments, feedback)

  if (isLoadingFeedback || isLoadingMerchant)
    return <Loader title={t('common.withYouShortly')} description={t('common.pleaseWait')} />
  if (merchant === null) {
    return <ErrorPage />
  }

  return (
    <div className="container container-centered">
      <div className="limited-width-container">
        <div className="credit-steps">
          <h3>{t('common.appNumber', { number: creditApp.referenceNumber })}</h3>
          <span style={{ textAlign: 'center' }}>
            {replaceWithNonBreakingHyphen(applicantFullName(creditApp.applicant))}
          </span>
        </div>
        <div className="credit-steps" style={{ marginTop: '2rem' }}>
          <div className="paragraph" style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <h4>
              <i className="fa-solid fa-party-horn" /> {t('common.congratulation')}{' '}
            </h4>
          </div>

          <DocumentsCreditStep creditApp={creditApp} />

          <ContractCreditStep
            creditApp={creditApp}
            skipBankAccountRequiredDocuments={skipBankAccountRequiredDocuments}
            applicantType={EApplicantType.Applicant}
          />

          <CreditStep
            status={feedbackStepStatus}
            linkToDetail="feed-back"
            title={t('overview.rateExperienceStep')}
            content={t('overview.rateExperienceContent')}
            hideLinkToDetail={feedbackStepStatus !== CreditStepStatus.RequiresAttention}
          />
        </div>
      </div>
    </div>
  )
}

export default OverviewPage
